import { ListItemIcon, ListItemText, Menu, MenuItem, MenuProps, PopoverOrigin } from "@mui/material";
import { IGWidget, TMouseEvent, addClass, appendClass } from "../GWidget";
import React, { SyntheticEvent, useEffect, useState } from "react";
import { NestedMenuItem } from "mui-nested-menu";

export interface TMenuOptions {
    icon?:JSX.Element;
    label?:string;
    element?:any
    value:string;
    onClick?:TMouseEvent,
    menu?:TMenuOptions[];
    menuPosition?:MenuAnchorProps;
}

export interface IMenuProps extends MenuProps, IGWidget {
    options:TMenuOptions[];
    onOption?:TMenuEvent;
    value?:string;
}
export type TMenuEvent = (e:SyntheticEvent, value:string) => void;
export type MenuAnchorProps = { anchorOrigin:PopoverOrigin, transformOrigin:PopoverOrigin};
export const BottomRightAnchor : MenuAnchorProps = {
    anchorOrigin:{vertical:"bottom",horizontal:"right"},
    transformOrigin:{vertical:"top",horizontal:"right"}
}

type TMenuCloseEvent = (e:any,reason:any) => void
function GMenuItem(props:{open:boolean,value?:string|undefined,option:TMenuOptions,onOption?:TMenuEvent,onClose:TMenuCloseEvent}) {
    const {option,value,onClose,onOption} = props

    const itemClass = appendClass("", value==option.value?"selected":"")
    const _onOption = (e:React.SyntheticEvent) => {
        onOption?.(e, option.value)
        onClose(e, "menuSelect")
        option.onClick?.(e)
    }

    if (option.menu) {
        const submenu = option.menu.map(option => {
            const {option:_,...menuProps} = props
            return <GMenuItem {...menuProps} option={option} key={option.value}/>
        })
        const menuProps = {...option.menuPosition}
        return <NestedMenuItem className={itemClass} leftIcon={option.icon} label={option.label||option.value} parentMenuOpen={props.open} MenuProps={menuProps}>
            {submenu}
        </NestedMenuItem>
    }
    else {
        const label = <>{option.icon ? <ListItemIcon>{option.icon}</ListItemIcon> : null}<ListItemText>{option.label||option.value}</ListItemText></>
        return option.element || <MenuItem className={itemClass} onClick={_onOption}>{label}</MenuItem>
    }
}

export default function GMenu(props:IMenuProps&MenuProps) {
    const {value,options,onOption,open:isOpen,onClose,...menuProps} = props
    const [open,setOpen] = useState<boolean>(isOpen||false)
    const onCloseMenu = (e:any, reason:any) => {
        setOpen(false)
        onClose?.(e, reason)
    }
    const rows = options.map(option => <GMenuItem key={option.value} open={open} value={value} option={option} onOption={onOption} onClose={onCloseMenu}/>)
    useEffect(() => {
        if (isOpen!=open) setOpen(isOpen||false)
    }, [isOpen])
    return <Menu id={props.id} className={addClass("", props)} {...menuProps} open={open && Boolean(menuProps.anchorEl)} onClose={onCloseMenu}>{rows}</Menu>
}